import { Communicator } from "./databin$"
import { CoordinatorService } from "./coordinator.service"
import { Subject } from "rxjs"
import { Connection } from "./connection"

export class OnlineCommunicator implements Communicator {

    fetchNumber: number = 10
    buttonCommunicator$ = new Subject()

    tag = "online"
    update$ = new Subject<void>()
    itmLs: Object[] = []

    private _term = ""

    constructor(public coords: CoordinatorService) {
        this.coords.databin$.communicatorStage$.subscribe(n => {
            switch (n) {
                case 1:
                    this._term = ""
                    break
                case 3:
                    const c = this.connection
                    if (!c.get('title')) {
                        const q = c.get('query')
                        let t = c.connector.tag
                        if (q)
                            t = `${t}: ${q}`
                        c.set('title', t)
                    }
                    break
            }
        })
    }

    get hasFetch() {
        if (!this.connection) return false
        const sp = this.connection.get("_searchParams")
        return !!sp
    }

    async load() {
        // https://chemcombo.fra1.digitaloceanspaces.com/RF-00000002-BGA/cas_RF-00000002-BGA_pubmed_2021-3-14.txt
        // https://ruzne.fra1.digitaloceanspaces.com/science.rss
        const txt = this._term.trim()

        if (!txt) return
        try {
            const url = new URL(txt)
            const resp = await fetch(url)
            const data = await resp.text()
            const c = this.connection

            c.set("sourceURL", url.toString())
            c.set("isFetchComplete", true)

            console.log("PARSE LOAD", data)
        } catch (e) {

        }
    }

    get isSubmitEnabled() {
        return !!this.term.trim()
    }

    clear() {
        this.term = ""
    }

    search(payload?: any) {
        if (!this.isSubmitEnabled) {
            return
        }
        const c = this.connection
        if (!c) return
        if (!payload) {
            payload = {
                term: this.term,
                prefetch: 10

            }
        }

        payload.connectionId = c.id
        c.command({ name: 'search-start' })
        this.coords.online$.post("search", c.connector.tag, payload)
    }

    private _fetch(c: Connection, size: number) {
        // console.log(this.connection)
        
        this.coords.online$.post("fetch", c.connector.tag, {
            sourceId: c.id,
            searchParams: c.get("_searchParams"),
            size: size
        })
        // this.coords.display$.closeDialog()
    }

    get connection() {
        return this.coords.databin$.editedConnection$.getValue()!
    }


    get isFetchDisabled() {
        const c = this.connection
        if (!c) return true

        if (!c.inProject) return false
        return c.activeFetchNumber > 0 ||
            c.get("_hits") <= c.size
    }

    setHelpId() {
        
        this.coords.display$.lastDialogAction = this.connection?.connector.tag
    }

    step2Next() {
        this.coords.databin$.communicatorStage$.next(3)
    }

    get info() {
        return {
            query: this.connection.get('query'),
            hits: this.connection.get('_hits')
        }
    }

    get size() {
        return this.connection.size
    }


    async confirm(payload?: any) {
        let n = this.fetchNumber
        const maxHits = this.connection.get("_hits")

        // '-1' represents 'all'
        if (n === -1 || n > maxHits) {
            n = maxHits
        }

        if (this.connection.inProject) {
            this.connection.set("title", payload.title)
            this.connection.set("description", payload.description)

            if (n) {
                this.connection.activeFetchNumber = n
                this._fetch(this.connection, n)
            }
        } else {
            // const ls = this.coords.databin$.communicatorUnconfirmedLs
            const ls = this.connection.previewLs
            const isFinal = ls.length <= n
            await this.connection.finalize(isFinal, n)

            if (this.connection.size < n) {
                this.connection.activeFetchNumber = n
                this._fetch(this.connection, n - this.connection.size)
            } else {
                this.connection.isFetchError = false
            }
        }

        this.coords.databin$.communicatorStage$.next(0)
    }

    get source() {
        const c = this.connection
        return c && this.coords.text(c.connector.tag)
    }

    get dialogTitle() {
        return this.source
    }

    public get term() {
        return this._term
    }
    public set term(value) {
        // if (this._term.trim() !== value.trim()) {
        //     this.coords.databin$.communicatorUnconfirmedLs = []
        // }
        this._term = value

        // this.buttonCommunicator$.next({ buttonId: "search", isDisabled: !this._term.trim() })
    }

}


